<div class="min-h-screen px-8 py-8 ltr:text-left rtl:text-right">
  <h1 class="text-primary mb-8 text-[28px] font-[700]" i18n="@@profileChangePasswordBreadcrumb">Change Password</h1>

  <div class="w-full rounded-[12px] bg-white p-8 shadow-[0px_0px_12px_1px_rgba(0,0,0,0.06)]">
    <div class="mb-4 flex items-center gap-2.5">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" class="text-black">
        <path
          d="M12 1C9.79086 1 8 2.79086 8 5V8H6C4.89543 8 4 8.89543 4 10V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V10C20 8.89543 19.1046 8 18 8H16V5C16 2.79086 14.2091 1 12 1Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
      <span class="text-text-heading text-[18px] font-[600]">
        {{ isAr ? "تغيير كلمة المرور" : "Change Password" }}
      </span>
    </div>

    <div class="bg-bg mb-8 h-[1.5px]"></div>

    @if (apiError()) {
      <div class="mb-6 rounded-[8px] border border-red-100 bg-red-50 px-4 py-3 text-[14px] text-red-600">
        {{ apiError() }}
      </div>
    }

    <form [formGroup]="form" (ngSubmit)="onSave()" class="flex flex-col gap-6">
      <div class="flex flex-col gap-1.5 md:w-1/2">
        <label class="text-text-body text-[13px] font-[500]" i18n="@@currentPassword">
          {{ isAr ? "كلمة المرور الحالية" : "Current Password" }}
        </label>
        <div class="relative">
          <input
            [type]="showCurrent ? 'text' : 'password'"
            formControlName="currentPassword"
            [placeholder]="isAr ? 'أدخل كلمة المرور الحالية' : 'Enter current password'"
            class="border-border-input-light text-text-body placeholder-text-placeholder-light focus-border-primary w-full rounded-[8px] border bg-white px-4 py-2.5 text-[14px] transition-all outline-none ltr:pr-10 rtl:pl-10"
            [class.!border-red-500]="form.get('currentPassword')?.invalid && form.get('currentPassword')?.touched" />
          <button
            type="button"
            (click)="showCurrent = !showCurrent"
            class="absolute top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 ltr:right-3 rtl:left-3">
            @if (showCurrent) {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                <line x1="1" y1="1" x2="23" y2="23" />
              </svg>
            } @else {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            }
          </button>
        </div>
        @if (getError("currentPassword")) {
          <span class="text-[11px] font-[500] text-red-600">{{ getError("currentPassword") }}</span>
        }
      </div>

      <div class="flex flex-col gap-1.5 md:w-1/2">
        <label class="text-text-body text-[13px] font-[500]" i18n="@@newPassword">
          {{ isAr ? "كلمة المرور الجديدة" : "New Password" }}
        </label>
        <div class="relative">
          <input
            [type]="showNew ? 'text' : 'password'"
            formControlName="newPassword"
            [placeholder]="isAr ? 'أدخل كلمة المرور الجديدة' : 'Enter new password'"
            class="border-border-input-light text-text-body placeholder-text-placeholder-light focus-border-primary w-full rounded-[8px] border bg-white px-4 py-2.5 text-[14px] transition-all outline-none ltr:pr-10 rtl:pl-10"
            [class.!border-red-500]="form.get('newPassword')?.invalid && form.get('newPassword')?.touched" />
          <button
            type="button"
            (click)="showNew = !showNew"
            class="absolute top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 ltr:right-3 rtl:left-3">
            @if (showNew) {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                <line x1="1" y1="1" x2="23" y2="23" />
              </svg>
            } @else {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            }
          </button>
        </div>
        @if (getError("newPassword")) {
          <span class="text-[11px] font-[500] text-red-600">{{ getError("newPassword") }}</span>
        }
      </div>

      <div class="flex flex-col gap-1.5 md:w-1/2">
        <label class="text-text-body text-[13px] font-[500]" i18n="@@confirmPassword">
          {{ isAr ? "تأكيد كلمة المرور الجديدة" : "Confirm New Password" }}
        </label>
        <div class="relative">
          <input
            [type]="showConfirm ? 'text' : 'password'"
            formControlName="confirmPassword"
            [placeholder]="isAr ? 'تأكيد كلمة المرور الجديدة' : 'Confirm new password'"
            class="border-border-input-light text-text-body placeholder-text-placeholder-light focus-border-primary w-full rounded-[8px] border bg-white px-4 py-2.5 text-[14px] transition-all outline-none ltr:pr-10 rtl:pl-10"
            [class.!border-red-500]="getError('confirmPassword')" />
          <button
            type="button"
            (click)="showConfirm = !showConfirm"
            class="absolute top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 ltr:right-3 rtl:left-3">
            @if (showConfirm) {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                <line x1="1" y1="1" x2="23" y2="23" />
              </svg>
            } @else {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            }
          </button>
        </div>
        @if (getError("confirmPassword")) {
          <span class="text-[11px] font-[500] text-red-600">{{ getError("confirmPassword") }}</span>
        }
      </div>

      <div class="flex items-center justify-end gap-3 pt-4">
        <button
          type="button"
          (click)="onCancel()"
          class="border-primary text-primary hover-bg-primary-10 cursor-pointer rounded-[8px] border px-8 py-2.5 text-[14px] font-[600] transition-all">
          {{ isAr ? "إلغاء" : "Cancel" }}
        </button>
        <button
          type="submit"
          [disabled]="loading() || form.invalid"
          class="bg-primary hover-bg-primary-hover cursor-pointer rounded-[8px] px-8 py-2.5 text-[14px] font-[600] text-white transition-all disabled:opacity-50">
          <div class="flex items-center gap-2">
            @if (loading()) {
              <span class="h-4 w-4 animate-spin rounded-full border-2 border-white/30 border-t-white"></span>
            }
            <span>{{ loading() ? (isAr ? "جاري الحفظ..." : "Saving...") : isAr ? "حفظ" : "Save" }}</span>
          </div>
        </button>
      </div>
    </form>
  </div>
</div>
